var _rect, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalizationAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_458_6",
    "data-name": "Component 458 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2667",
    "data-name": "Rectangle 2667",
    width: 30,
    height: 30,
    rx: 5,
    fill: "#181d25"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "AR",
    transform: "translate(4 20)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "Nunito-Bold, Nunito",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AR"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalizationAr);
export default __webpack_public_path__ + "static/media/localization-ar.3aa03892ad7889caac63635ba879bdac.svg";
export { ForwardRef as ReactComponent };